import styled from 'styled-components'

export const Logo = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  min-height: 6rem;
`

export const Image = styled.img`
  height: ${(props) => (props.theme.collapsed ? 'auto' : '6rem')};
  width: ${(props) => (props.theme.collapsed ? '4.8rem' : 'auto')};
`
